import { Diagnostic } from "../models/diagnostic.js";

/**
 * Checks for iOS development related issues on macOS systems.
 * RULES:
 * 1. XCODE MISSING (xcodebuild unavailable)
 * 2. COCOAPODS MISSING (pod unavailable)
 */
export function checkIosDiagnostic(
  isMac: boolean,
  xcodebuildAvailable: boolean,
  podAvailable: boolean
): Diagnostic[] {
  if (!isMac) {
    return [];
  }

  const diagnostics: Diagnostic[] = [];

  // 1. XCODE MISSING
  if (!xcodebuildAvailable) {
    diagnostics.push({
      id: "xcode-missing",
      title: "Xcode Missing",
      severity: "error",
      detected: "xcodebuild command was not found on your system.",
      explanation: "Xcode is required to compile, build, sign, and run iOS applications. The xcodebuild binary is the CLI runner for Xcode.",
      symptoms: [
        "iOS builds are impossible to compile",
        "React Native CLI run-ios commands fail with missing SDK errors",
      ],
      fixes: [
        "Download Xcode from the Mac App Store or Apple Developer Portal.",
        "Ensure Command Line Tools are installed: run 'xcode-select --install' in terminal.",
        "Check Xcode selection: run 'sudo xcode-select -s /Applications/Xcode.app/Contents/Developer'.",
      ],
      documentationUrl: "https://developer.apple.com/xcode/",
    });
  }

  // 2. COCOAPODS MISSING
  if (!podAvailable) {
    diagnostics.push({
      id: "cocoapods-missing",
      title: "CocoaPods (pod) Missing",
      severity: "error",
      detected: "pod command was not found on your system.",
      explanation: "CocoaPods is the native dependency manager for iOS projects. iOS native dependencies cannot be installed without it.",
      symptoms: [
        "Unable to install native iOS packages (e.g. running pod install inside the ios folder fails)",
        "Missing native framework references during Xcode compilation",
      ],
      fixes: [
        "Install CocoaPods via Homebrew: 'brew install cocoapods' (Recommended).",
        "Alternatively, install via Ruby Gems: 'sudo gem install cocoapods'.",
      ],
      documentationUrl: "https://guides.cocoapods.org/using/getting-started.html",
    });
  }

  return diagnostics;
}
